<template lang="pug">
#media-tab
  b-field(:label="account.premium_episodes ? 'Publish / Privacy' : 'Publish'")
  b-field(grouped)
    b-field
      b-switch(
        type="is-success"
        :value="episode.is_published"
        @input="set($event, 'is_published')"
      )
    b-field(
      v-if="episode.is_published"
      expanded
    )
      b-datepicker(
        icon="calendar-today"
        :value="episode.pub_date"
        :date-formatter="tempFormatter"
        @input="set($event, 'pub_date')"
        expanded
      )
      p.control(v-if="account.premium_episodes")
        a.button(@click="set(!episode.is_premium, 'is_premium')")
          b-icon(:icon="episode.is_premium ? 'lock' : 'lock-open-variant'")
  b-field(
    label="Title"
    expanded
    :type="errors.has('title') ? 'is-danger' : ''"
    :message="errors.first('title')"
  )
    b-input(
      type="text"
      name="title"
      v-validate="'required'"
      :value="episode.title"
      @input="set($event, 'title')"
    )
  b-field(label="Channel(s)")
    elasticsearch-multiselect(
      field="title"
      icon="podcast"
      index="doxa_channels"
      placeholder="Search by title..."
      :value="episode.channel_ids"
      @input="set($event, 'channel_ids')"
    )
  b-field(label="Video Link")
    video-field(
      :value="episode._embedded.video"
    )
  b-field(label="Audio File")
    audio-player(
      v-if="sources.length > 0"
      :sources="sources"
      :html5="true"
      :audio="episode._embedded.audio"
      @delete-audio="deleteAudio"
    )
    div(v-else)
      b-upload(
        v-model="file"
        @input="saveAudio"
        drag-drop
      )
        section.section
          .content.has-text-centered
            b-icon(icon="file-music" size="is-large")
            p Drop an MP3 to upload
            progress.progress.is-small.is-primary(
              :value="settings.uploading"
              max="100"
              v-show="settings.uploading > 0"
            )
</template>

<script>
import { mapGetters } from 'vuex';
import { HTTP } from '@/utils/http';
import AudioPlayer from '@/components/AudioPlayer';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import VideoField from '@/components/form/VideoField';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'details-tab',
  components: {
    AudioPlayer,
    ElasticsearchMultiselect,
    VideoField,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      episode: getters.GET_EPISODE,
    }),
    sources() {
      if (this.episode._embedded.audio.id) {
        return [this.episode._embedded.audio.stream_url];
      }
      return [];
    },
  },
  data() {
    return {
      file: null,
      settings: {
        uploading: 0,
      },
    };
  },
  methods: {
    async deleteAudio() {
      await this.$store.dispatch(actions.DO_DELETE_MEDIA, {
        id: this.episode._embedded.audio.id,
      });
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key: '_embedded.audio',
        val: {},
      });
    },
    async saveAudio() {
      const self = this;
      const payload = new FormData();
      payload.append('file', this.file);
      const config = {
        onUploadProgress(progressEvent) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          self.settings.uploading = progress;
        },
      };
      const { data } = await HTTP.post('/media/audio', payload, config);
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key: '_embedded.audio',
        val: data.data.audio[0],
      });
      this.settings.uploading = 0;
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key,
        val,
      });
    },
    tempFormatter(date) {
      const yyyyMMdd = [
        date.getFullYear(),
        (date.getMonth() + 1),
        date.getDate(),
      ].join('/');
      const d = new Date(yyyyMMdd);
      return d.toLocaleDateString();
    },
  },
};
</script>

<style lang="scss">
#media-tab {
  min-height: 390px;
  .upload {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/episode/MediaTab.vue